<!--
 * @Author: DY
 * @Date: 2025-04-27 17:41:35
 * @LastEditTime: 2025-04-28 15:04:20
 * @Description: 库存查看[库存查询-扫码-库存查看]
 * @FilePath: \ShiMo_Mobile\src\views\storage\inventoryInquiry\inventoryView.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="inventoryView commonFormStyles">
            <HeaderNav
                header-title="库存查看"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <ul class="formList">
                <li>
                    <van-field
                        disabled
                        label="库位编号"
                        :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                        v-model="formData.GridCode"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="库位名称"
                        :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                        v-model="formData.GridName"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="仓库名称"
                        :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                        v-model="formData.StockName"
                    ></van-field>
                </li>
                <div class="info_box">
                    <div class="list_item" v-for="(item, index) in formData.materials" :key="index">
                        <p class="title">
                            <span>物料代码：{{ item.MaterialCode }}</span>
                            <span>短描述：{{ item.MaterialShortName }}</span>
                        </p>
                        <div class="ps_box">
                            <div class="list_item_card list_item_card2">
                                <div>当前库存：</div>
                                <div>
                                    <van-field
                                        disabled
                                        v-model="item.VolumeCurrent"
                                        label="文本"
                                        label-align="right"
                                    >
                                    </van-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ul>
            <footer class="currencyFooterStyle">
                <van-button type="primary" loading-type="spinner" @click="swiperright">
                    关闭
                </van-button>
            </footer>
        </div>
    </v-touch>
</template>

<script>
import NP from 'number-precision';
NP.enableBoundaryChecking(false);
import { HeaderNav } from '@/components/';
export default {
    name: 'inventory-view',
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            formData: {},
        };
    },
    computed: {},
    watch: {},
    activated() {},
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },

        async initpage() {
            const res = await this.getInventoryInfo(this.$route.params.grid_code);
            if (res) {
                this.formData = res;
            } else {
                this.$toast('未获取到库位信息！');
            }
        },

        // 获取库存信息
        getInventoryInfo(grid_code) {
            return this.$axios.$get(`/interfaceApi/procurement/stock_grid/volume_info/${grid_code}`);
        },
    },
};
</script>
<style lang="stylus">
.inventoryView
    height 100%
    position relative
    background #f0f0f0
    .info_box
        background #fff
        padding 10rpx
        .van-cell__right-icon
            color #666
        .list_item
            background #fff
            margin-bottom 15rpx
            box-shadow: 0px 0px 3px 0px #b5b5b5;
            border-radius: 8rpx;
            position relative
            .title
                width 100%
                height 50rpx
                background #F8F8F8
                margin-bottom 0 !important
                display flex
                align-items center
                padding 0 20rpx
                box-shadow: 0px 2px 3px -2px #b5b5b5;
                font-size 14rpx
                font-weight: 550;
                position relative
                border-radius: 8rpx 8rpx 0 0;
                display: flex;
                justify-content: space-between;
                span
                    color: #000 !important
                .btn
                    position absolute
                    top 0
                    right 0
                    color #fff !important
                    font-size 13rpx !important
                    background: #f86565;
                    padding 2rpx 5rpx
                    border-radius: 0 8rpx
                    font-weight: 500 !important;
                    &.btn_ok
                        background #ccc !important
            .ps_box
                padding 15px
                display: flex
                flex-wrap: wrap;
                justify-content: space-between;
                .list_item_card
                    width 100%
                    >div
                        &:last-child
                            margin-top: 6rpx
                    input
                        width 100%
                    .van-cell__title
                        display none
                    .van-cell
                        border: none;
                        background #FAFBFE
                        border-radius 6rpx
</style>
